<!-- <p>asset-settings-dialog works!</p> -->
<div
  [ngClass]="{
    'asset-settings-container': data.screen == 1 || data.screen == 2,
    'asset-settings-container-mobile': data.screen == 3
  }"
>
  <h1 mat-dialog-title>Asset Settings</h1>
  <mat-divider></mat-divider>
  <mat-dialog-content>
    <div *ngIf="data.algo == 'setting' && false" class="asset-settings-content">
      <form
        class="example-form"
        [formGroup]="AssetSettingForm"
        (ngSubmit)="alertFormValues(AssetSettingForm)"
        ngNativeValidate
      >
        <div class="settings-labels">
          <mat-slide-toggle formControlName="enableIntrusion"
            >Enable Intrusion</mat-slide-toggle
          >
          <br />
          <mat-slide-toggle formControlName="enablePeopleDetect"
            >Enable Peope Detection</mat-slide-toggle
          >
          <br />
          <mat-slide-toggle formControlName="enableVehicleDetect"
            >Enable Vehicle Detection</mat-slide-toggle
          >
          <br />
          <mat-slide-toggle formControlName="enableFire"
            >Enable Fire</mat-slide-toggle
          >
          <br />
          <!-- <mat-slide-toggle formControlName="acceptTerms"
            >Accept Terms of Service</mat-slide-toggle
          ><br /> -->
        </div>

        <!-- <p>Form Group Status: {{ AssetSettingForm.status }}</p> -->
      </form>
    </div>
    <div *ngIf="data.algo == 'intrusion'" class="asset-settings-content">
      <form [formGroup]="AssetSettingForm" ngNativeValidate>
        <div class="settings-labels">
          <mat-slide-toggle formControlName="intrusion">{{
            AssetSettingForm.controls.intrusion.value
              ? "Disable Intrusion Detection"
              : "Enable Intrusion Detection"
          }}</mat-slide-toggle>

          <br />
          <mat-slide-toggle
            *ngIf="AssetSettingForm.controls.intrusion.value"
            formControlName="animalDetection"
            >{{
              AssetSettingForm.controls.animalDetection.value
                ? "Disable Animal Detection"
                : "Enable Animal Detection"
            }}</mat-slide-toggle
          >
          <br />
          <mat-slide-toggle
            *ngIf="AssetSettingForm.controls.intrusion.value"
            formControlName="vehicleDetection"
            >{{
              AssetSettingForm.controls.vehicleDetection.value
                ? "Disable Vehicle Detection"
                : "Enable Vehicle Detection"
            }}</mat-slide-toggle
          >
          <br />
        </div>
      </form>
    </div>
    <div *ngIf="data.algo == 'fire'" class="asset-settings-content">
      <form [formGroup]="AssetSettingForm" ngNativeValidate>
        <div class="settings-labels">
          <mat-slide-toggle formControlName="fire">{{
            AssetSettingForm.controls.fire.value
              ? "Disable Fire Detection"
              : "Enable Fire Detection"
          }}</mat-slide-toggle>
          <br />
        </div>
      </form>
    </div>
    <div *ngIf="data.algo == 'anpr'" class="asset-settings-content">
      <form [formGroup]="AssetSettingForm" ngNativeValidate>
        <div class="settings-labels">
          <mat-slide-toggle formControlName="anpr">{{
            AssetSettingForm.controls.anpr.value
              ? "Disable ANPR Detection"
              : "Enable ANPR Detection"
          }}</mat-slide-toggle>
          <br />
        </div>
        <div class="settings-labels" *ngIf="AssetSettingForm.controls.anpr.value">
          <mat-slide-toggle formControlName="fullFrame">{{
            AssetSettingForm.controls.fullFrame.value
              ? "Disable Full Frame"
              : "Enable Full Frame"
          }}</mat-slide-toggle>
          <br />
        </div>
      </form>
    </div>
    <div *ngIf="data.algo == 'face'" class="asset-settings-content">
      <form [formGroup]="AssetSettingForm" ngNativeValidate>
        <div class="settings-labels">
          <mat-slide-toggle formControlName="faceRecognization">{{
            AssetSettingForm.controls.anpr.value
              ? "Disable Face Recognition"
              : "Enable Face Recognition"
          }}</mat-slide-toggle>
          <br />
        </div>
      </form>
    </div>

    <mat-divider></mat-divider> </mat-dialog-content
  ><mat-dialog-actions>
    <button mat-raised-button [mat-dialog-close]="false">Cancel</button>
    <button
      [disabled]="AssetSettingForm.controls.faceRecognization.pristine"
      *ngIf="data.algo == 'face'"
      mat-raised-button
      [mat-dialog-close]="AssetSettingForm.value"
    >
      {{ AssetSettingForm.controls.faceRecognization.value ? "Start" : "Save" }}
    </button>
    <button
      [disabled]="AssetSettingForm.controls.fire.pristine"
      *ngIf="data.algo == 'fire'"
      mat-raised-button
      [mat-dialog-close]="AssetSettingForm.value"
    >
      {{ AssetSettingForm.controls.fire.value ? "Start" : "Save" }}
    </button>
    <button
      [disabled]="
        AssetSettingForm.controls.anpr.pristine ||
        AssetSettingForm.controls.anpr.value === data.assetDetails.anpr
      "
      *ngIf="data.algo == 'anpr'"
      mat-raised-button
      [mat-dialog-close]="AssetSettingForm.value"
    >
      {{ AssetSettingForm.controls.anpr.value ? "Start" : "Save" }}
    </button>
    <button
      [disabled]="
        AssetSettingForm.controls.intrusion.value ===
          data.assetDetails.intrusion &&
        AssetSettingForm.controls.animalDetection.value ===
          data.assetDetails.animalDetection &&
        AssetSettingForm.controls.vehicleDetection.value ===
          data.assetDetails.vehicleDetection
      "
      *ngIf="data.algo == 'intrusion'"
      mat-raised-button
      [mat-dialog-close]="AssetSettingForm.value"
    >
      {{ !AssetSettingForm.controls.intrusion.value ? "Start" : "Save" }}
    </button>
    <button
      *ngIf="data.algo == 'setting'"
      mat-raised-button
      [mat-dialog-close]="AssetSettingForm.value"
    >
      Save
    </button>
  </mat-dialog-actions>
</div>
